var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 6.05176L5.68066 7.2002H4.48828L7.75488 10.4668V9.27441L8.90234 8.12598L9.67969 8.90332L8.86328 9.7207V11.5752L8.08594 12.3525L5.73242 10L2.88184 12.8516H2.10352V12.0742L4.95508 9.22266L2.60254 6.87012L3.37988 6.0918H5.23438L6.05078 5.27441L6.82812 6.05176ZM13.8975 5.72266L13.1201 6.50098L12.6016 5.98242L11.1016 7.48145L10.3242 6.7041L11.8242 5.20508L9.75 3.13086L8.25 4.62988L7.47266 3.85254L8.97266 2.35352L8.4541 1.83496L9.23242 1.05762L13.8975 5.72266Z",
    fill: "#813C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4012 10.0322L8.60957 7.8611L5.1358 4.34057C5.1358 4.02946 4.58748 4.43763 4.66269 4.13061C4.7379 3.82357 4.85072 3.53094 5.00114 3.25269L5.75754 4.00909C5.68831 4.17858 5.63638 4.35072 5.60176 4.52551C5.56714 4.70028 6.15819 4.75861 6.15819 4.9387L7.12751 5.77123L10.4012 10.0322L1.70117 1.35782L2.40371 0.655273L14.2986 12.5501L13.596 13.2527L11.355 11.0322L10.4012 10.0322Z",
    fill: "#813C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnpin);
export default __webpack_public_path__ + "static/media/ic_unpin.36d3c4cb50b0fcf49f976c25571cf7f3.svg";
export { ForwardRef as ReactComponent };